import { get as _get } from "lodash";
import { Box, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";

// components
import TokenLogo from "../TokenLogo";

/**
 * Token row for the token lists: logo, name and a secondary line (the symbol unless given).
 * A row is either clickable (onClick) or carries its own control on the right (action).
 */
const TokenListItem = ({ token, secondary, onClick, action, highlighted = false }) => {
  const rowSx = {
    display: "flex",
    alignItems: "center",
    gap: 1,
    width: "100%",
    borderRadius: "12px",
    px: 1.5,
    py: 0.75,
    ...(highlighted ? { bgcolor: "background.light" } : {}),
  };
  const content = (
    <>
      <ListItemIcon sx={{ minWidth: 44 }}>
        <TokenLogo token={token} size={36} />
      </ListItemIcon>
      <ListItemText
        primary={_get(token, "name", "")}
        secondary={secondary ?? _get(token, "symbol", "")}
        sx={{ minWidth: 0 }}
        slotProps={{
          primary: { noWrap: true, sx: { fontWeight: 500 } },
          secondary: { noWrap: true, sx: { color: "text.secondary" } },
        }}
      />
    </>
  );

  return (
    <ListItem disablePadding sx={{ px: 1 }}>
      {onClick ? (
        <ListItemButton onClick={onClick} sx={rowSx}>
          {content}
        </ListItemButton>
      ) : (
        <Box sx={rowSx}>
          {content}
          {action ? <Box sx={{ flexShrink: 0 }}>{action}</Box> : null}
        </Box>
      )}
    </ListItem>
  );
};

export default TokenListItem;
